import { safeDefine } from "../../registration/safe-define.js";
import { LiveVideoSkinElement } from "../../presets/live-video/skin.js";
import "../../internal/skins/default-live-video/register.js";
//#region src/define/live-video/skin.ts
safeDefine(LiveVideoSkinElement);
//#endregion
